import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button, Table, Badge, NavDropdown, Nav, Card, Modal, Form, Spinner, ProgressBar
} from 'react-bootstrap';
import Select from 'react-select';

const getApiUrl = () => localStorage.getItem('apiUrl') || 'http://localhost:8000';

const fmt = (val) => {
  const num = parseFloat(val) || 0;
  return num.toLocaleString('id-ID');
};

export default function BayarPiutang() {
  const navigate = useNavigate();
  const [, setMenus] = useState([]);
  const [time, setTime] = useState({ date: '', clock: '' });

  // Filter state
  const [tipeJaminan, setTipeJaminan] = useState('1');
  const [listPerusahaan, setListPerusahaan] = useState([]);
  const [selectedPrs, setSelectedPrs] = useState(null);

  // Data state
  const [listPiutang, setListPiutang] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Progress state
  const [progressMsg, setProgressMsg] = useState('SIAP');
  const [progressVal, setProgressVal] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);

  // Alert state
  const [alertState, setAlertState] = useState({ show: false, message: '', variant: 'info' });
  const showAlert = (message, variant = 'info') => setAlertState({ show: true, message, variant });

  // PDF Modal
  const [showModalPdf, setShowModalPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfTitle, setPdfTitle] = useState('');
  // Angsuran Modal
    // Cetak Modal
  const [showModalCetak, setShowModalCetak] = useState(false);
  const [periodeCetak1, setPeriodeCetak1] = useState('');
  const [periodeCetak2, setPeriodeCetak2] = useState('');

  // Format YYYY-MM-DD to DD/MM/YYYY for backend
  const formatTgl = (tgl) => {
    if (!tgl) return '';
    const [y, m, d] = tgl.split('-');
    return `${d}/${m}/${y}`;
  };
  // Angsuran Modal
  const [showModalAngsuran, setShowModalAngsuran] = useState(false);
  const [listAngsuran, setListAngsuran] = useState([]);
  const [totalAngsuran, setTotalAngsuran] = useState(0);
  const [isAngsuranLoading, setIsAngsuranLoading] = useState(false);

  // Tipe Jaminan options
  const tipeOptions = [
    { value: '1', label: 'Perusahaan rekanan' },
    { value: '2', label: 'Dokter Rumah Sakit' },
    { value: '3', label: 'Pegawai rumah sakit' },
  ];

  // Clock & Menu
  useEffect(() => {
    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) { try { setMenus(JSON.parse(savedMenu)); } catch (e) { setMenus([]); } }
    const updateTime = () => {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, '0');
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const hh = String(now.getHours()).padStart(2, '0');
      const mi = String(now.getMinutes()).padStart(2, '0');
      const ss = String(now.getSeconds()).padStart(2, '0');
      setTime({ date: `${dd}/${mm}/${now.getFullYear()}`, clock: `${hh}:${mi}:${ss}` });
    };
    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  // Fetch Perusahaan for dropdown
  const fetchPerusahaan = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/show_perusahaan?token=${encodeURIComponent(token)}`);
      const json = await res.json();
      setListPerusahaan(Array.isArray(json.list_perusahaan) ? json.list_perusahaan : []);
    } catch (err) {
      setListPerusahaan([]);
    }
  }, []);

  useEffect(() => { fetchPerusahaan(); }, [fetchPerusahaan]);

  // Fetch piutang data
  const fetchPiutang = async () => {
    if (!selectedPrs) { showAlert('Pilih Kode / Nama Perusahaan terlebih dahulu!', 'warning'); return; }
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      // 1. Call prosestagih first to calculate/update pelunasan table
      setProgressMsg('MEMPROSES TAGIHAN...');
      setProgressVal(15);
      
      const payloadProses = {
        txtkdprs: selectedPrs.value,
        txtnmprs: selectedPrs.label.split('|')[1]?.trim() || '',
        cmbtypejamin: tipeJaminan
      };
      
      await fetch(`${getApiUrl()}/prosestagih?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payloadProses)
      });
      
      setProgressMsg('MEMUAT DATA...');
      setProgressVal(40);

      // 2. Fetch the updated piutang data
      const res = await fetch(
        `${getApiUrl()}/show_piutang?kdprs=${encodeURIComponent(selectedPrs.value)}&typeprs=${tipeJaminan}&token=${encodeURIComponent(token)}`
      );
      const json = await res.json();
      setListPiutang(Array.isArray(json.list_piutang) ? json.list_piutang : []);
      setProgressMsg('DATA BERHASIL DIMUAT');
      setProgressVal(100);
      setTimeout(() => { setProgressMsg('SIAP'); setProgressVal(0); }, 1500);
    } catch (err) {
      showAlert('Gagal mengambil data piutang: ' + err.message, 'danger');
      setProgressMsg('GAGAL');
      setProgressVal(0);
    } finally {
      setIsLoading(false);
    }
  };

  // Totals
  const totalNilaiTagihan = listPiutang.reduce((s, r) => s + (r.total || 0), 0);
  const totalTolakBayar = listPiutang.reduce((s, r) => s + (r.sisa || 0), 0);
  const totalPelunasan = listPiutang.reduce((s, r) => s + (r.pembayaran || 0), 0);
  const totalSaldo = listPiutang.reduce((s, r) => s + (r.saldo || 0), 0);

  // Cetak PDF helper
  const cetakPdf = async (endpoint, title, payload) => {
    setProgressMsg(`MENCETAK ${title}...`);
    setProgressVal(20);
    setIsProcessing(true);
    const interval = setInterval(() => {
      setProgressVal(prev => prev < 85 ? prev + 10 : prev);
    }, 300);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/${endpoint}?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error('Server error');
      const blob = await res.blob();
      clearInterval(interval);
      setProgressVal(100);
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      setPdfTitle(title);
      setShowModalPdf(true);
      setProgressMsg('SELESAI');
      setTimeout(() => { setProgressMsg('SIAP'); setProgressVal(0); }, 1500);
    } catch (err) {
      clearInterval(interval);
      setProgressVal(0);
      setProgressMsg('GAGAL');
      showAlert('Gagal mencetak: ' + err.message, 'danger');
    } finally {
      setIsProcessing(false);
    }
  };

  
  const handleShowAngsuran = async () => {
    if (!selectedPrs) {
      showAlert('Pilih Kode / Nama Perusahaan terlebih dahulu!', 'warning');
      return;
    }
    setShowModalAngsuran(true);
    setIsAngsuranLoading(true);
    try {
      const token = localStorage.getItem('token');
      const payload = {
        txtkdprs: selectedPrs.value,
        cmbtypejamin: tipeJaminan
      };
      
      const res = await fetch(`${getApiUrl()}/show_angsuran?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      if (json.status === 1) {
        setListAngsuran(Array.isArray(json.data) ? json.data : []);
        setTotalAngsuran(json.total_angsuran || 0);
      } else {
        showAlert(json.msg || 'Gagal memuat data angsuran.', 'danger');
        setListAngsuran([]);
        setTotalAngsuran(0);
      }
    } catch (err) {
      showAlert('Terjadi kesalahan: ' + err.message, 'danger');
    } finally {
      setIsAngsuranLoading(false);
    }
  };

  const handleProsesPelunasan = async () => {
    if (!selectedPrs || listPiutang.length === 0) {
      showAlert('Tidak ada data piutang untuk diproses!', 'warning');
      return;
    }
    setProgressMsg('MEMPROSES PELUNASAN...');
    setProgressVal(10);
    setIsProcessing(true);
    const interval = setInterval(() => {
      setProgressVal(prev => prev < 85 ? prev + 8 : prev);
    }, 300);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/proses_pelunasan?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kdprs: selectedPrs.value, typeprs: tipeJaminan })
      });
      const json = await res.json();
      clearInterval(interval);
      setProgressVal(100);
      if (json.status === 1 || json.status === 'success') {
        showAlert(json.msg || 'Pelunasan berhasil diproses!', 'success');
        fetchPiutang();
      } else {
        showAlert(json.msg || 'Gagal memproses pelunasan.', 'danger');
      }
      setProgressMsg('SELESAI');
      setTimeout(() => { setProgressMsg('SIAP'); setProgressVal(0); }, 1500);
    } catch (err) {
      clearInterval(interval);
      setProgressVal(0);
      setProgressMsg('GAGAL');
      showAlert('Terjadi kesalahan: ' + err.message, 'danger');
    } finally {
      setIsProcessing(false);
    }
  };

  const prsOptions = listPerusahaan.map(p => ({
    value: p.kode,
    label: `${p.kode} | ${p.perusahaan}`,
    sublabel: p.jln || p.kawasan || ''
  }));

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f0f4f8', fontFamily: "'Inter', 'Segoe UI', sans-serif", display: 'flex', flexDirection: 'column' }}>

      {/* TOP NAV */}
      <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #0ea5e9 100%)', padding: '0 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: '46px', boxShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
        <div className="d-flex align-items-center gap-2">
          <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '7px', padding: '4px 8px' }}>
            <i className="bi bi-building-check text-warning" style={{ fontSize: '1.1rem' }}></i>
          </div>
          <div>
            <span className="fw-bold text-white" style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>BAYAR PIUTANG</span>
            <span className="text-white-50 ms-2" style={{ fontSize: '0.72rem' }}>| Pelunasan Piutang dan Perhitungan Hutang Jasa Medis</span>
          </div>
        </div>
        <div className="d-flex align-items-center gap-3">
          <div className="text-end">
            <div className="text-white fw-semibold" style={{ fontSize: '0.75rem', fontFamily: 'monospace' }}>{time.clock}</div>
            <div className="text-white-50" style={{ fontSize: '0.68rem' }}>{time.date}</div>
          </div>
          <Button size="sm" onClick={() => navigate('/home')} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: '6px', padding: '3px 10px', fontSize: '0.75rem', fontWeight: 600 }}>
            <i className="bi bi-house-fill me-1"></i>Home
          </Button>
        </div>
      </div>

      {/* MENU BAR */}
      <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 1rem' }}>
        <Nav className="flex-row">
          <NavDropdown title="Transaksi" id="nav-dropdown-trx" className="fw-semibold" style={{ fontSize: '0.8rem' }}>
            <NavDropdown.Item style={{ fontSize: '0.8rem' }}>Proses Pelunasan</NavDropdown.Item>
            <NavDropdown.Item style={{ fontSize: '0.8rem' }}>Saldo Pelunasan</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Laporan" id="nav-dropdown-lap" className="fw-semibold" style={{ fontSize: '0.8rem' }}>
            <NavDropdown.Item onClick={() => setShowModalCetak(true)} style={{ fontSize: '0.8rem' }}>Cetak Summary Pelunasan</NavDropdown.Item>
            <NavDropdown.Item onClick={() => cetakPdf('cetak_rekapitulasi_piutang', 'REKAPITULASI PIUTANG', { kdprs: selectedPrs?.value, typeprs: tipeJaminan })} style={{ fontSize: '0.8rem' }}>Cetak Rekapitulasi</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </div>

      <Card className="m-2 shadow-sm flex-grow-1" style={{ border: 'none', borderRadius: '10px', display: 'flex', flexDirection: 'column' }}>
        {/* CARD HEADER - Sub title */}
        <Card.Header className="py-2 px-3 fw-bold text-white text-center" style={{ background: 'linear-gradient(90deg, #1e3a5f, #0284c7)', fontSize: '0.88rem', letterSpacing: '0.8px', borderRadius: '10px 10px 0 0' }}>
          REKAPITULASI PIUTANG DAN PROSES PERHITUNGAN HUTANG JASA MEDIS
        </Card.Header>

        <Card.Body className="p-2 d-flex flex-column" style={{ background: '#f8fafc', flex: 1 }}>

          {/* FILTER BAR */}
          <div className="bg-white border shadow-sm rounded mb-2 p-2 d-flex align-items-center gap-3 flex-wrap" style={{ borderColor: '#e2e8f0' }}>
            {/* Tipe Jaminan */}
            <div className="d-flex align-items-center gap-2" style={{ flex: '0 0 auto' }}>
              <div className="fw-bold text-white px-2 py-1 rounded shadow-sm" style={{ background: '#1e3a5f', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                <i className="bi bi-shield-check me-1 text-warning"></i>TIPE JAMINAN
              </div>
              <div style={{ width: '220px' }}>
                <Select
                  options={tipeOptions}
                  value={tipeOptions.find(o => o.value === tipeJaminan) || null}
                  onChange={(sel) => { setTipeJaminan(sel ? sel.value : '1'); setListPiutang([]); }}
                  isSearchable={false}
                  menuPosition="fixed"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({ ...base, minHeight: '32px', height: '32px', fontSize: '0.8rem', borderColor: '#cbd5e1', boxShadow: 'none' }),
                    valueContainer: (base) => ({ ...base, padding: '0 10px' }),
                    indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                    menu: (base) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            <div className="vr" style={{ height: '24px', backgroundColor: '#cbd5e1' }}></div>

            {/* Kode Perusahaan */}
            <div className="d-flex align-items-center gap-2 flex-grow-1">
              <div className="fw-bold text-white px-2 py-1 rounded shadow-sm" style={{ background: '#1e3a5f', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                <i className="bi bi-building me-1 text-warning"></i>KODE | NAMA PERUSAHAAN
              </div>
              <div style={{ flex: 1, minWidth: '220px' }}>
                <Select
                  options={prsOptions}
                  value={selectedPrs}
                  onChange={(sel) => { setSelectedPrs(sel); setListPiutang([]); }}
                  placeholder="🔍 Cari kode / nama perusahaan..."
                  isSearchable={true}
                  isClearable={true}
                  noOptionsMessage={() => 'Perusahaan tidak ditemukan'}
                  formatOptionLabel={(opt) => (
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '0.8rem', color: '#1e293b' }}>{opt.label}</div>
                      {opt.sublabel && <div style={{ fontSize: '0.7rem', color: '#64748b' }}>{opt.sublabel}</div>}
                    </div>
                  )}
                  menuPosition="fixed"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({ ...base, minHeight: '30px', height: '30px', fontSize: '0.8rem', borderColor: '#ced4da' }),
                    valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                    indicatorsContainer: (base) => ({ ...base, height: '30px' }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#0ea5e9' : state.isFocused ? '#f0f9ff' : '#fff',
                      color: state.isSelected ? '#fff' : '#1e293b',
                      padding: '6px 10px'
                    })
                  }}
                />
              </div>
              <Button
                size="sm"
                onClick={fetchPiutang}
                disabled={isLoading || !selectedPrs}
                className="fw-bold d-flex align-items-center gap-1"
                style={{ background: 'linear-gradient(135deg, #1e3a5f, #0ea5e9)', border: 'none', fontSize: '0.78rem', whiteSpace: 'nowrap', borderRadius: '6px', padding: '4px 12px' }}
              >
                {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-search"></i>}
                Tampilkan
              </Button>
            </div>
          </div>

          {/* TABLE */}
          <div className="flex-grow-1 bg-white border shadow-sm rounded overflow-auto" style={{ borderColor: '#e2e8f0', minHeight: '300px' }}>
            <Table hover size="sm" className="mb-0 align-middle" style={{ fontSize: '0.78rem' }}>
              <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                <tr style={{ background: 'linear-gradient(90deg, #1e3a5f, #155e8a)', color: '#fff' }}>
                  <th className="px-2 py-2 fw-semibold text-center" style={{ fontSize: '0.72rem', letterSpacing: '0.3px', width: '5%' }}>#</th>
                  <th className="px-2 py-2 fw-semibold text-center" style={{ width: '10%' }}>TANGGAL TAGIH</th>
                  <th className="px-2 py-2 fw-semibold" style={{ width: '20%' }}>NOMOR KUITANSI PENAGIHAN</th>
                  <th className="px-2 py-2 fw-semibold text-end" style={{ width: '12%' }}>NILAI TAGIHAN [Rp]</th>
                  <th className="px-2 py-2 fw-semibold text-end" style={{ width: '12%' }}>TOLAK BAYAR [Rp]</th>
                  <th className="px-2 py-2 fw-semibold text-end" style={{ width: '12%' }}>PELUNASAN [Rp]</th>
                  <th className="px-2 py-2 fw-semibold text-end" style={{ width: '12%' }}>SALDO [Rp]</th>
                  <th className="px-2 py-2 fw-semibold" style={{ width: '12%' }}>NOMOR PELUNASAN</th>
                  <th className="px-2 py-2 fw-semibold text-center" style={{ width: '5%' }}>KD. BANK</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      <Spinner animation="border" variant="primary" className="me-2" />
                      <span className="text-muted fw-semibold">Memuat data piutang...</span>
                    </td>
                  </tr>
                ) : listPiutang.length > 0 ? (
                  listPiutang.map((item, idx) => (
                    <tr key={idx} style={{
                      background: idx % 2 === 0 ? '#fff' : '#f8fafc',
                      borderBottom: '1px solid #f1f5f9',
                      color: item.proses === 'X' ? '#94a3b8' : '#1e293b'
                    }}>
                      <td className="text-center text-muted px-2" style={{ fontSize: '0.7rem' }}>{idx + 1}</td>
                      <td className="text-center px-2">{item.tgl_tagih}</td>
                      <td className="px-2 fw-medium" style={{ color: '#0284c7' }}>{item.no_kuitansi}</td>
                      <td className="text-end px-2 fw-semibold">{fmt(item.total)}</td>
                      <td className="text-end px-2 text-danger">{fmt(item.sisa)}</td>
                      <td className="text-end px-2 text-success fw-semibold">{fmt(item.pembayaran)}</td>
                      <td className="text-end px-2 fw-bold" style={{ color: item.saldo > 0 ? '#dc2626' : '#16a34a' }}>{fmt(item.saldo)}</td>
                      <td className="px-2">{item.no_pelunasan || '-'}</td>
                      <td className="text-center px-2">
                        {item.kd_bank ? (
                          <Badge bg="info" style={{ fontSize: '0.65rem' }}>{item.kd_bank}</Badge>
                        ) : '-'}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      <div className="mb-2"><i className="bi bi-inbox fs-3 opacity-30"></i></div>
                      <div className="text-muted" style={{ fontSize: '0.8rem' }}>
                        {selectedPrs ? 'Tidak ada data piutang.' : 'Pilih Perusahaan dan klik Tampilkan untuk melihat data.'}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>

              {/* TOTAL FOOTER */}
              {listPiutang.length > 0 && (
                <tfoot style={{ position: 'sticky', bottom: 0 }}>
                  <tr style={{ background: 'linear-gradient(90deg, #1e3a5f, #155e8a)', color: '#fff', fontWeight: 700 }}>
                    <td colSpan="3" className="px-2 py-2 text-end fw-bold" style={{ fontSize: '0.78rem', letterSpacing: '0.5px' }}>
                      TOTAL [Rp]
                    </td>
                    <td className="text-end px-2 py-2" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{fmt(totalNilaiTagihan)}</td>
                    <td className="text-end px-2 py-2" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{fmt(totalTolakBayar)}</td>
                    <td className="text-end px-2 py-2 text-warning" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{fmt(totalPelunasan)}</td>
                    <td className="text-end px-2 py-2" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{fmt(totalSaldo)}</td>
                    <td colSpan="2"></td>
                  </tr>
                </tfoot>
              )}
            </Table>
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap align-items-center gap-2 mt-2 pt-2 border-top" style={{ borderColor: '#e2e8f0' }}>
            <Button
              size="sm"
              disabled={isProcessing || listPiutang.length === 0}
              onClick={handleProsesPelunasan}
              className="fw-bold d-flex align-items-center gap-1 shadow-sm"
              style={{ background: listPiutang.length === 0 ? '#94a3b8' : 'linear-gradient(135deg, #1e3a5f, #0ea5e9)', border: 'none', fontSize: '0.78rem', borderRadius: '6px', padding: '5px 12px' }}
            >
              <i className="bi bi-check2-circle"></i> PROSES PELUNASAN
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={isProcessing || !selectedPrs}
              onClick={handleShowAngsuran}
              className="fw-bold d-flex align-items-center gap-1 shadow-sm"
              style={{ fontSize: '0.78rem', borderRadius: '6px' }}
            >
              <i className="bi bi-wallet2"></i> SALDO PELUNASAN
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                const today = new Date().toISOString().split('T')[0];
                if (!periodeCetak1) setPeriodeCetak1(today);
                if (!periodeCetak2) setPeriodeCetak2(today);
                setShowModalCetak(true);
              }}
              className="fw-bold d-flex align-items-center gap-1 shadow-sm"
              style={{ fontSize: '0.78rem', borderRadius: '6px' }}
            >
              <i className="bi bi-printer-fill"></i> CETAK SUMMARY PELUNASAN
            </Button>
            <Button
              variant="outline-success"
              size="sm"
              disabled={isProcessing || listPiutang.length === 0}
              onClick={() => cetakPdf('cetak_rekapitulasi_piutang', 'REKAPITULASI', { kdprs: selectedPrs?.value, typeprs: tipeJaminan })}
              className="fw-bold d-flex align-items-center gap-1 shadow-sm"
              style={{ fontSize: '0.78rem', borderRadius: '6px' }}
            >
              <i className="bi bi-file-earmark-bar-graph-fill"></i> CETAK REKAPITULASI
            </Button>
            <div className="ms-auto">
              <Button
                variant="light"
                size="sm"
                onClick={() => navigate('/home')}
                className="fw-bold d-flex align-items-center gap-1 border shadow-sm"
                style={{ fontSize: '0.78rem', borderRadius: '6px', color: '#dc2626', borderColor: '#fca5a5' }}
              >
                <i className="bi bi-x-circle-fill text-danger"></i> TUTUP
              </Button>
            </div>
          </div>

          {/* PROGRESS BAR */}
          <div className="mt-2 rounded overflow-hidden" style={{ background: '#1e3a5f', padding: '4px 10px', minHeight: '28px' }}>
            <div className="d-flex align-items-center gap-2">
              <span className="text-white fw-bold" style={{ fontSize: '0.72rem', letterSpacing: '2px', fontFamily: 'monospace' }}>
                {'|' + progressMsg.split('').join('|') + '|'}
              </span>
              {progressVal > 0 && progressVal < 100 && (
                <ProgressBar
                  animated
                  now={progressVal}
                  className="flex-grow-1"
                  style={{ height: '10px', borderRadius: '5px' }}
                />
              )}
            </div>
          </div>

        </Card.Body>
      </Card>

      {/* MODAL PDF */}
      <Modal show={showModalPdf} onHide={() => { setShowModalPdf(false); setTimeout(() => setPdfUrl(''), 300); }} size="xl" centered backdrop="static">
        <Modal.Header closeButton style={{ background: '#1e293b', color: '#fff', borderBottom: '2px solid #0ea5e9' }} className="py-2 px-3">
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: 600 }}>
            <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
            {pdfTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 bg-light" style={{ height: '75vh' }}>
          {pdfUrl ? (
            <iframe src={pdfUrl} title={pdfTitle} width="100%" height="100%" style={{ border: 'none' }} />
          ) : (
            <div className="d-flex h-100 justify-content-center align-items-center">
              <Spinner animation="border" className="text-primary me-2" />
              <span className="text-muted fw-semibold">Memuat dokumen PDF...</span>
            </div>
          )}
        </Modal.Body>
      </Modal>

                  {/* MODAL CETAK SUMMARY */}
      <Modal show={showModalCetak} onHide={() => setShowModalCetak(false)} size="sm" centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)', color: '#fff', borderBottom: 'none' }} className="py-3 px-4">
          <Modal.Title style={{ fontSize: '0.95rem', fontWeight: 600, letterSpacing: '0.5px', display: 'flex', alignItems: 'center' }}>
            <i className="bi bi-calendar2-range text-info me-2 fs-5"></i>
            PERIODE PELUNASAN
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4" style={{ backgroundColor: '#f8fafc' }}>
          
          <div className="mb-3">
            <label className="fw-semibold text-muted mb-1" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>TANGGAL AWAL</label>
            <div className="input-group input-group-sm shadow-sm rounded">
              <span className="input-group-text bg-white border-end-0 text-muted">
                <i className="bi bi-calendar-event"></i>
              </span>
              <Form.Control
                type="date"
                className="border-start-0"
                style={{ fontWeight: 600, color: '#334155', fontSize: '0.85rem' }}
                value={periodeCetak1}
                onChange={e => setPeriodeCetak1(e.target.value)}
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="fw-semibold text-muted mb-1" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>SAMPAI DENGAN</label>
            <div className="input-group input-group-sm shadow-sm rounded">
              <span className="input-group-text bg-white border-end-0 text-muted">
                <i className="bi bi-calendar-event"></i>
              </span>
              <Form.Control
                type="date"
                className="border-start-0"
                style={{ fontWeight: 600, color: '#334155', fontSize: '0.85rem' }}
                value={periodeCetak2}
                onChange={e => setPeriodeCetak2(e.target.value)}
              />
            </div>
          </div>
          
          <div className="d-flex flex-column gap-2">
            <Button
              className="fw-bold shadow-sm d-flex justify-content-center align-items-center gap-2 py-2"
              style={{ background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)', border: 'none', borderRadius: '8px', fontSize: '0.85rem' }}
              onClick={() => {
                setShowModalCetak(false);
                cetakPdf('cetak_summary_pelunasan', 'SUMMARY PELUNASAN', { 
                  kdprs: selectedPrs ? selectedPrs.value : '', 
                  typeprs: tipeJaminan,
                  periode1: formatTgl(periodeCetak1),
                  periode2: formatTgl(periodeCetak2)
                });
              }}
            >
              <i className="bi bi-printer"></i> PROSES CETAK
            </Button>
            <Button
              variant="light"
              onClick={() => setShowModalCetak(false)}
              className="fw-bold d-flex justify-content-center align-items-center gap-2 py-2 border shadow-sm"
              style={{ fontSize: '0.85rem', borderRadius: '8px', color: '#64748b' }}
            >
              TUTUP
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* MODAL ANGSURAN */}
      <Modal show={showModalAngsuran} onHide={() => setShowModalAngsuran(false)} size="lg" centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)', color: '#fff', borderBottom: 'none' }} className="py-2 px-3">
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: 600, letterSpacing: '0.5px' }}>
            <i className="bi bi-wallet2 text-warning me-2"></i>
            RINCIAN SALDO PELUNASAN
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 bg-light d-flex flex-column" style={{ maxHeight: '70vh' }}>
          
          {/* Info Header */}
          <div className="px-3 py-2 border-bottom d-flex align-items-center gap-2" style={{ background: '#fff' }}>
            <Badge bg="info" className="fs-6 px-2 py-1">{selectedPrs?.value}</Badge>
            <span className="fw-bold text-secondary" style={{ fontSize: '0.85rem' }}>{selectedPrs?.label?.split('|')[1]?.trim()}</span>
          </div>

          <div className="flex-grow-1 overflow-auto p-3">
            <div className="bg-white border shadow-sm rounded overflow-hidden" style={{ borderColor: '#e2e8f0' }}>
              <Table hover size="sm" className="mb-0 align-middle" style={{ fontSize: '0.8rem' }}>
                <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr style={{ background: '#f8fafc', color: '#334155', borderBottom: '2px solid #cbd5e1' }}>
                    <th className="py-2 px-2 text-center" style={{ width: '5%' }}>#</th>
                    <th className="py-2 px-2 text-center" style={{ width: '20%' }}>NO. PELUNASAN</th>
                    <th className="py-2 px-2 text-center" style={{ width: '15%' }}>TGL BANK</th>
                    <th className="py-2 px-2" style={{ width: '20%' }}>REKENING</th>
                    <th className="py-2 px-2" style={{ width: '20%' }}>NAMA BANK</th>
                    <th className="py-2 px-2 text-end" style={{ width: '20%' }}>PEMBAYARAN [Rp]</th>
                  </tr>
                </thead>
                <tbody>
                  {isAngsuranLoading ? (
                    <tr>
                      <td colSpan="6" className="text-center py-5">
                        <Spinner animation="border" size="sm" className="text-primary me-2" />
                        <span className="text-muted">Memuat data...</span>
                      </td>
                    </tr>
                  ) : listAngsuran.length > 0 ? (
                    listAngsuran.map((item, idx) => (
                      <tr key={idx}>
                        <td className="text-center text-muted">{idx + 1}</td>
                        <td className="text-center fw-semibold text-primary">{item.no_pelunasan}</td>
                        <td className="text-center">{item.tgl_bank}</td>
                        <td>{item.no_rekening}</td>
                        <td>{item.nm_bank}</td>
                        <td className="text-end fw-bold text-success">{fmt(item.pembayaran)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4 text-muted">
                        <i className="bi bi-inbox fs-4 mb-2 d-block opacity-50"></i>
                        Tidak ada riwayat saldo pelunasan.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          
          <div className="px-3 py-2 border-top d-flex justify-content-between align-items-center" style={{ background: '#fff' }}>
            <span className="fw-bold text-secondary" style={{ fontSize: '0.8rem' }}>TOTAL ANGSURAN:</span>
            <span className="fw-bold" style={{ fontSize: '1.1rem', color: '#dc2626', fontFamily: 'monospace' }}>
              Rp {fmt(totalAngsuran)}
            </span>
          </div>
        </Modal.Body>
      </Modal>

      {/* MODAL ALERT */}
      <Modal show={alertState.show} onHide={() => setAlertState({ ...alertState, show: false })} centered size="sm">
        <Modal.Body className="text-center p-4">
          <div className={`text-${alertState.variant} mb-3`}>
            {alertState.variant === 'success' && <i className="bi bi-check-circle-fill" style={{ fontSize: '3.5rem' }}></i>}
            {alertState.variant === 'warning' && <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '3.5rem' }}></i>}
            {alertState.variant === 'danger' && <i className="bi bi-x-circle-fill" style={{ fontSize: '3.5rem' }}></i>}
            {alertState.variant === 'info' && <i className="bi bi-info-circle-fill" style={{ fontSize: '3.5rem' }}></i>}
          </div>
          <h5 className="mb-3 fw-bold" style={{ color: '#334155' }}>
            {alertState.variant === 'success' ? 'Berhasil!' : alertState.variant === 'warning' ? 'Perhatian!' : alertState.variant === 'danger' ? 'Gagal!' : 'Informasi'}
          </h5>
          <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>{alertState.message}</p>
          <Button
            variant={alertState.variant}
            className="w-100 fw-bold rounded-pill shadow-sm"
            onClick={() => setAlertState({ ...alertState, show: false })}
          >
            OK, MENGERTI
          </Button>
        </Modal.Body>
      </Modal>

    </div>
  );
}
